import { Record, List } from 'immutable';
import CountryTimeZoneRecord from './CountryTimeZoneRecord';

const keys = {
  code: '',
  translationKey: '',
  timeZones: List(),
  countryTimeZones: List(),
};

interface Fields {
  code: string;
  translationKey: string;
  timeZones: List<string>; //Todo: Remove when TIME_ZONES_AS_OBJECTS is removed
  countryTimeZones: List<CountryTimeZoneRecord>;
}

export const getFirstTimeZone = (
  inviteRequestCountryRecord: InviteRequestCountryRecord
): string => {
  if (
    inviteRequestCountryRecord.countryTimeZones &&
    inviteRequestCountryRecord.countryTimeZones.count() > 0
  ) {
    return inviteRequestCountryRecord.countryTimeZones.get(0)!.name; // eslint-disable-line @typescript-eslint/no-non-null-assertion
  }

  if (
    inviteRequestCountryRecord.timeZones &&
    inviteRequestCountryRecord.timeZones.count() > 0
  ) {
    return inviteRequestCountryRecord.timeZones.get(0) as string;
  }

  throw new Error('No timezones available.');
};

export default class InviteRequestCountryRecord extends Record<Fields>(keys) {
  constructor(values?) {
    super(values);

    if (values) {
      if (values.countryTimeZones) {
        return this.set(
          'countryTimeZones',
          List(
            values.countryTimeZones.map(
              (countryTimeZone) => new CountryTimeZoneRecord(countryTimeZone)
            )
          )
        );
      }

      if (values.timeZones) {
        return this.set('timeZones', List(values.timeZones));
      }
    }
  }
}
